import { Button } from '@steelwake/ui';
import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';

import { api, describeError } from '../api.js';
import { Card, Field, Notice, PageTitle } from '../ui.js';

export function Register() {
  const [email, setEmail] = useState('');
  const [callsign, setCallsign] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await api<{ message: string }>('/api/v1/auth/register', {
        method: 'POST',
        body: { email, password, callsign },
      });
      setDone(res.message);
    } catch (err) {
      setError(describeError(err));
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <Card>
        <PageTitle>Check your email</PageTitle>
        <Notice kind="success" testId="register-success">
          {done}
        </Notice>
        <p>
          Open the verification link we sent, then <Link to="/login">log in</Link>.
        </p>
      </Card>
    );
  }

  return (
    <Card>
      <PageTitle>Create your account</PageTitle>
      <form onSubmit={submit} noValidate>
        <Field
          label="Email"
          name="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Field
          label="Callsign"
          name="callsign"
          autoComplete="username"
          required
          hint="3–16 letters, digits, or underscores"
          value={callsign}
          onChange={(e) => setCallsign(e.target.value)}
        />
        <Field
          label="Password"
          name="password"
          type="password"
          autoComplete="new-password"
          required
          hint="At least 10 characters"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error ? (
          <Notice kind="error" testId="form-error">
            {error}
          </Notice>
        ) : null}
        <Button type="submit" disabled={busy}>
          {busy ? 'Creating…' : 'Create account'}
        </Button>
      </form>
      <p>
        Already have one? <Link to="/login">Log in</Link>
      </p>
    </Card>
  );
}
